<ng-container>
  @if (type !== barcodeType.qr && isValidBarcode) {
    <ngx-barcode6
      #barcode
      [bc-value]="value"
      [bc-format]="renderBarcodeType"
      [bc-element-type]="'svg'"
      [bc-font-size]="12"
      [bc-height]="height"
      [bc-width]="width"
      [bc-background]="'transparent'"
      [bc-display-value]="displayValue"
    >
    </ngx-barcode6>
  }

  @if (type === barcodeType.qr) {
    <qrcode [qrdata]="value" [elementType]="'url'" [width]="100" [errorCorrectionLevel]="'M'"> </qrcode>
  }
</ng-container>
